import { PATHS } from '@src/consts'
import { homePagePath, useCustomRouter } from '@src/hooks'
import { usePostCanaryRoutingCheck } from '@src/hooks'
import { getUser, isOAuthRequest } from '@src/utils'

export const useMoveToNextUrl = () => {
  const { router, isString } = useCustomRouter()
  const query = router.query
  const loginChallenge = isString(query.login_challenge)
    ? query.login_challenge
    : ''
  const canaryRoutingCheckMutation = usePostCanaryRoutingCheck()

  function moveToNextUrl() {
    const user = getUser()
    const backUrl = isString(query.backUrl) ? query.backUrl : ''
    if (!user) return

    // Execute canary routing check before any post-login redirect
    canaryRoutingCheckMutation
      .mutateAsync()
      .then(() => {
        executePostLoginRedirect()
      })
      .catch(() => {
        // continue with redirect even if canary check fails
        executePostLoginRedirect()
      })

    function executePostLoginRedirect() {
      if (!user) return

      //TODO: When SAML information can be retrieved by user-api, add a condition whether SAML is enforced or not.
      if (user.isTempPassword) {
        router.push({ pathname: PATHS.REGISTER_PASSWORD })
      } else if (backUrl) {
        window.location.replace(backUrl)
      } else if (loginChallenge) {
        router.push({
          pathname: PATHS.OAUTH_AUTHORIZE_ACCEPT,
          query: {
            login_challenge: loginChallenge,
            subject: user.id,
          },
        })
      } else if (isOAuthRequest()) {
        router.push({ pathname: PATHS.SIGNIN_GRANT_CODE })
      } else {
        homePagePath(user)
      }
    }
  }

  return { moveToNextUrl }
}
